import scrollToElement from 'scroll-to-element';
import Axios from 'core/axios';
import Rest from 'core/rest';
import Validation from 'core/validation';
import { i18n } from 'core/i18n';
import {
	openMask,
	closeMask,
	openError
} from '../mainModule/action';

export const PROFILE_CLEAR = 'PROFILE_CLEAR';
export const PROFILE_GET_AGENT_SUCCESS = 'PROFILE_GET_AGENT_SUCCESS';
export const PROFILE_PUT_AGENT_SUCCESS = 'PROFILE_PUT_AGENT_SUCCESS';
export const PROFILE_UPDATE_AGENT_INFO = 'PROFILE_UPDATE_AGENT_INFO';
export const PROFILE_POST_ERROR = 'PROFILE_POST_ERROR';
export const PROFILE_CLEAR_ERROR = 'PROFILE_CLEAR_ERROR';

export function clearProfile() {
	return (dispatch) => {
		dispatch({
			type: PROFILE_CLEAR
		});
	};
}

export function getAgent() {
  return (dispatch) => {
		dispatch(openMask());
		return Axios.get(Rest.agent.getAgent())
			.then(async(response) => {
				const { data = {} } = response;
				await dispatch({
					type: PROFILE_GET_AGENT_SUCCESS,
					data
				});
				return dispatch(closeMask());
			})
			.catch((error) => {
				dispatch(closeMask());
				return dispatch(openError(error));
			});
  };
}

export function putAgent(data) {
	return (dispatch) => {
		// 清空所有錯誤
		dispatch({
			type: PROFILE_CLEAR_ERROR
		});

		// 欄位驗證
		const errors = Validation.validateAgentInfo(data);
		
		// confirm check (email)
		if (data && data.confirmEmail !== data.email) {
			errors.confirmEmail = i18n('error_confirm_email');
		}
		// confirm check (password)，有修改密碼才需檢核
		if (data && data.hasOwnProperty('password') && data.confirmPassword !== data.password) {
			errors.confirmPassword = i18n('error_confirm_password');
		}

		if (errors && JSON.stringify(errors) !== '{}') {
			// 視窗滾動至最上方錯誤欄位
			let scrollTo = null;
			if (errors.preferredLanguage) {
				// 滾動至設定區塊
				scrollTo = 'setting';
			} else if (errors.title || errors.firstName || errors.lastName
				|| errors.mobilePhone || errors.workPhone || errors.email || errors.confirmEmail) {
				// 滾動至聯絡人詳細資訊區塊
				scrollTo = 'contact';
			} else if (errors.address1 || errors.city || errors.addressState || errors.country) {
				// 滾動至地址區塊
				scrollTo = 'address';
			}
			
			if (scrollTo) {
				scrollToElement(`.profile-panel.${scrollTo}`, {
					offset: -100,
					ease: 'out-circ',
					duration: 1500
				});
			}

			// 驗證失敗，顯示錯誤
			return dispatch({
				type: PROFILE_POST_ERROR,
				errors
			});
		} else {
			// 驗證成功，打API
			dispatch(openMask());
			
			let requestData = JSON.parse(JSON.stringify(data));
			
			// 拔除多餘key
			if (requestData.confirmEmail) delete requestData.confirmEmail;
			if (requestData.confirmPassword) delete requestData.confirmPassword;

			// 若電話第一碼為0，需拔除第一碼0
			requestData.mobilePhone.number = (requestData.mobilePhone.number).replace(/^([0]*)([1-9]+[0-9]+)$/, '$2');
			requestData.workPhone.number = (requestData.workPhone.number).replace(/^([0]*)([1-9]+[0-9]+)$/, '$2');
			
			let user = JSON.parse(sessionStorage.getItem('user')),
				role = 1,
				agentId = '';
				
			// role: 0 (主帳號); role: 1 (子帳號);
			if (user && (user.role || user.role === 0)) role = user.role;

			// 編輯子帳號時，query需帶入agentId
			if (user && user.role === 1 && user.agentId) agentId = user.agentId;

			switch(role) {
			case 0:
				return Axios.put(Rest.agent.putMainAgent(), requestData)
					.then(() => {
						dispatch(closeMask());
						return dispatch({
							type: PROFILE_PUT_AGENT_SUCCESS
						});
					})
					.catch((error) => {
						dispatch(closeMask());
						return dispatch(openError(error));
					});
			case 1:
			default:
				return Axios.put(Rest.agent.putAgent(agentId), requestData)
					.then(() => {
						dispatch(closeMask());
						return dispatch({
							type: PROFILE_PUT_AGENT_SUCCESS
						});
					})
					.catch((error) => {
						dispatch(closeMask());
						return dispatch(openError(error));
					});
			}
		}
  };
}

export function updateAgentInfo(data) {
	return (dispatch) => {
		dispatch({
			type: PROFILE_UPDATE_AGENT_INFO,
			data
		});
	};
}